import { Link, Table } from '@flos/react-ui';
import type { RowInformation } from '../../config/flavourConfig';
import { formatCoverableFieldValue } from '../../utils/coverablesUtil';
import { useState } from 'react';

const TableRowWithBullets = ({ rowInfo }: { rowInfo: RowInformation }): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Table.Row>
            <Table.Cell>
                {rowInfo.name}
                {rowInfo.subtext?.map((item, index) => (
                    <ul key={index} className="u-display-flex u-flex-justify-between">
                        {item.isTitleInteractive ? (
                            <>
                                <Link
                                    className="u-color-primary-2-base"
                                    onClick={() => {
                                        setShowModal(true);
                                    }}
                                >
                                    <li>{item.title}</li>
                                </Link>
                                <span className="u-Nowrap">
                                    {formatCoverableFieldValue(item.value ?? '')}
                                </span>
                                {showModal && item.modalInformation && (
                                    <item.modalInformation.modalType
                                        showModal={showModal}
                                        modalProps={item.modalInformation.modalProps}
                                        closeModal={() => {
                                            setShowModal(false);
                                        }}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                <li>{item.title}</li>
                                <span className="u-Nowrap">
                                    {formatCoverableFieldValue(item.value ?? '')}
                                </span>
                            </>
                        )}
                    </ul>
                ))}
            </Table.Cell>
        </Table.Row>
    );
};

export default TableRowWithBullets;
